import {
  DashboardCustomize as ComponentIcon,
  Fastfood as ProductIcon,
  LightMode as LocationIcon,
  Person as PersonIcon,
  Settings as SettingsIcon,
  ViewQuiltOutlined as AssemblyIcon,
} from '@mui/icons-material';
import { useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import CCLogoImage from 'src/assets/images/navbar/CCLogo.svg?react';
import { AuthDataProvider } from 'src/components/authProvider';
import { PATHS } from 'src/constants/paths';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { getPaths } from 'src/utils';
import { SB_API_URL } from 'src/utils/environment';

import { useCloseSnackBar } from './Navbar.hook';
import { Link, Logo, Menu, Wrapper } from './Navbar.styled';

export const Navbar = () => {
  const { userRole } = useContext(AuthDataProvider);
  const location = useLocation();
  const paths = getPaths(location.pathname).slice(1);
  const {
    locationCode = '',
    scheduleAssemblyId = '',
    assemblyId = '',
    componentId = '',
  } = useParams();

  useCloseSnackBar();
  const items = [
    { path: PATHS.COMPONENTS, icon: <ComponentIcon />, label: 'Components' },
    { path: PATHS.ASSEMBLIES, icon: <AssemblyIcon />, label: 'Assemblies' },
    {
      path: PATHS.LOCATION_GROUPS,
      icon: <LocationIcon />,
      label: 'Locations',
    },
    { path: PATHS.PRODUCTS, icon: <ProductIcon />, label: 'Products' },
    { path: PATHS.SETTINGS, icon: <SettingsIcon />, label: 'Settings' },
  ];

  const itemsOO = [
    {
      path: PATHS.OO_LOCATION_PAGE,
      icon: <LocationIcon />,
      label: 'Locations',
    },
  ];

  const isAssemblyDetailsPage =
    paths.includes(PATHS.ASSEMBLY_DETAILS(assemblyId)) ||
    paths.includes(
      `${PATHS.ASSEMBLY_OVERRIDES(locationCode, scheduleAssemblyId)}`,
    );

  const isComponentDetailsPage = paths.includes(
    PATHS.COMPONENT_DETAILS(componentId),
  );

  return (
    <Wrapper>
      <Link
        to={
          userRole !== AuthClassification.OWNER_OPERATOR
            ? PATHS.ASSEMBLIES
            : PATHS.OO_LOCATION_PAGE
        }>
        <Logo>
          <CCLogoImage />
        </Logo>
      </Link>

      {userRole !== AuthClassification.OWNER_OPERATOR ? (
        <Menu>
          {items.map((item, index) => {
            const isLocations = item.label === 'Locations';
            const isSelected = isLocations
              ? location.pathname.startsWith('/locations')
              : paths.includes(item.path.split('?')[0]);

            return (
              <li key={index}>
                <Link to={item.path} $isSelected={isSelected}>
                  <>
                    {item.icon}
                    {item.label}
                  </>
                </Link>
              </li>
            );
          })}
        </Menu>
      ) : (
        <Menu>
          {itemsOO.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                $isSelected={
                  paths.includes(item.path) ||
                  isAssemblyDetailsPage ||
                  isComponentDetailsPage
                }>
                <>
                  {item.icon}
                  {item.label}
                </>
              </Link>
            </li>
          ))}
        </Menu>
      )}

      <Link to={SB_API_URL} target="_blank">
        <PersonIcon />
        Profile
      </Link>
    </Wrapper>
  );
};
